module.exports = __webpack_public_path__ + "img/non-approve.406bc463.svg";